<template>
  <div>
    <div>
      <subpage-header back-link="admin/user-list" label="Create a new user" />
      <div class="spl-edit-template">
        <div class="spl-edit-template__step spl-user-management">
          <div class="spl-h3">
            User Information
          </div>
          <div class="col6">
            <form-label>Full Name</form-label>
            <form-input v-model="user_model.Full_Name" :required="true" />
            <form-label>Email</form-label>
            <div style="display: flex; gap: 10px; align-items: flex-end;">
              <div style="flex: 1;">
                <form-input
                  v-model="user_model.Email"
                  :required="true"
                  :validate-email="true" />
              </div>
              <form-button
                v-if="isEditMode && user_model.qrCodePath"
                :wide="false"
                @onClick="downloadQrCode">
                Download QR Code
              </form-button>
            </div>
          </div>
          <div class="row">
            <div class="col3">
              <form-label>Type</form-label>
              <form-filtered-select
                v-model="user_model.User_Type"
                :options="userTypeOptions"
                :selected-key="user_model.User_Type" />
            </div>
          </div>
          <div v-if="!isEditMode" class="row">
            <div class="col6">
              <form-checkbox
                v-model="user_model.AutoGeneratePassword"
                name="AutoGeneratePassword"
                :checked="user_model.AutoGeneratePassword">
                Auto-generate password (This will make it impossible to set a custom password)
              </form-checkbox>
            </div>
          </div>
        </div>
        <div class="spl-edit-template__step spl-user-management">
          <div class="spl-h3">
            SPLIT Permissions
          </div>
          <div class="row">
            <div class="col6">
              <form-label>Roles</form-label>
              <form-filtered-multiselect
                v-model="user_model.Role_IDs"
                :options="userRoles"
                label="Name"
                track-by="Role_ID" />
            </div>
          </div>
        </div>
        <div class="spl-edit-template__step spl-user-management">
          <div class="spl-h3">
            Customers Permissions
          </div>
          <div class="row">
            <div class="col12">
              <form-label>Customer</form-label>
              <form-checkbox
                v-model="user_model.All_Customers"
                name="All_Customers"
                :checked="user_model.All_Customers">
                All Customers
              </form-checkbox>
              <customer-multiselect
                :disabled="user_model.All_Customers"
                :selected-keys="user_model.Customer_Claims || []"
                @valuesSelected="onCustomersSelected" />
            </div>
          </div>
        </div>
        <div class="spl-edit-template__step spl-user-management">
          <div class="spl-h3">
            Country Permissions
          </div>
          <div class="row">
            <div class="col12">
              <form-label>Countries</form-label>
              <form-checkbox
                v-model="user_model.All_Countries"
                name="All_Countries"
                :checked="user_model.All_Countries">
                All Countries
              </form-checkbox>
              <country-multiselect
                :disabled="user_model.All_Countries"
                :selected-keys="user_model.Country_Claims || []"
                @valuesSelected="onCountriesSelected" />
            </div>
          </div>
        </div>
        <div class="spl-edit-template__step spl-user-management">
          <div class="row">
            <div class="col2">
              <form-button
                :wide="true"
                :secondary="true"
                @onClick="cancel">
                Cancel
              </form-button>
            </div>
            <div class="col2">
              <form-button :wide="true" @onClick="save">
                Save
              </form-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <message-modal />
  </div>
</template>
<script lang="ts">
import webApi from '../webApi'
import constants from '../constants'
import { mapGetters, mapState, mapActions } from 'vuex'
import { find } from 'lodash'
import { ManagedUserModel } from '../webApi/DataModels'
export default {
  name: 'CreateUser',
  data () {
    return {
      user_model: {
        Permission_User_ID: '',
        Full_Name: '',
        User_Type: 'time:matters',
        Email: '',
        Role_IDs: [],
        All_Countries: true,
        Country_Claims: [],
        All_Customers: true,
        Customer_Claims: [],
        SPLIT_User_ID: 0,
        AutoGeneratePassword: false,
        qrCodePath: null
      },
      userTypeOptions: [
        { value: 'time:matters', label: 'time:matters' },
        { value: 'Customer', label: 'Customer' },
        { value: 'Provider', label: 'Provider' }
      ]
    }
  },
  computed: {
    ...mapGetters('country', ['countryOptions']),
    ...mapGetters('customer', ['customerOptions']),
    ...mapState('userManagment', ['userList', 'userRoles']),
    isEditMode () {
      return !!this.$route.params.user_id
    }
  },
  mounted () {
    this.headerHolder = this.$el.querySelector('.spl-edit-template__step-header-holder')
    this.stepElems = this.$el.querySelectorAll('.spl-edit-template__step')
    if (this.$route.params.user_id) {
      if (this.userList.length === 0) {
        this.loadUserList().then(this.fillUser)
      } else {
        this.fillUser()
      }
    }
  },
  methods: {
    ...mapActions('userManagment', ['loadUserList']),
    // The user changed is mind, no new user should be created => back to dashboard
    cancel () {
      this.$router.push('/admin/user-list')
    },
    fillUser () {
      var user:ManagedUserModel = find(this.userList, { Permission_User_ID: this.$route.params.user_id }) as ManagedUserModel
      this.user_model.Full_Name = user.Full_Name
      this.user_model.Email = user.Email
      this.user_model.All_Customers = user.All_Customers
      this.user_model.All_Countries = user.All_Countries
      this.user_model.Role_IDs = user.Role_IDs
      this.user_model.User_Type = user.User_Type
      this.user_model.Country_Claims = user.Country_Claims
      this.user_model.Customer_Claims = user.Customer_Claims
      this.user_model.Permission_User_ID = user.Permission_User_ID
      this.user_model.SPLIT_User_ID = user.SPLIT_User_ID
      this.user_model.AutoGeneratePassword = user.qrCodePath != null
      this.user_model.qrCodePath = user.qrCodePath
    },
    // Create new user
    save () {
      this.user_model.Id = ''
      // Add Customer persmissions
      if (this.user_model.All_Customers) {
        this.user_model.Customer_Claims = []
      }
      // Add Country persmissions
      if (this.user_model.All_Countries) {
        this.user_model.Country_Claims = []
      }
      var userModel:ManagedUserModel = this.user_model as ManagedUserModel
      if (this.$route.name === 'edit-user') {
        webApi.account.update_User(userModel)
          .then((response) => {
            this.$toast('You successfully updated the user.', constants.defaultToastOptions())
            this.$router.push('/admin/user-list')
          }).catch((response) => {
            window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
          })
      } else {
        webApi.account.create_User(userModel)
          .then((response) => {
            this.$toast('You successfully created the user.', constants.defaultToastOptions())
            this.$router.push('/admin/user-list')
          }).catch((response) => {
            window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
          })
      }
    },
    // The checkbox for a country has been clicked, so we update the parameter.
    updateRolesValue (isChecked, index) {
      let realIndex = 0
      this.user_model.Roles.forEach((item, index2) => {
        if (this.user_model.Roles[index].Role_ID === item.Role_ID) realIndex = index2
      })
      this.user_model.Roles[realIndex].Selected = isChecked
    },
    onCustomersSelected (customers) {
      this.user_model.Customer_Claims = customers
    },
    onCountriesSelected (countries) {
      this.user_model.Country_Claims = countries
    },
    downloadQrCode () {
      // Call the backend to download the QR code
      webApi.account.downloadUserQrCode(this.user_model.SPLIT_User_ID)
        .then((response: any) => {
          const blob = new Blob([response.data])
          if ((window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveBlob(blob, 'qrcode.png')
          } else {
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'qrcode.png'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          this.$toast('QR code downloaded successfully.', constants.defaultToastOptions())
        }).catch((response: any) => {
          const errorMessage = response.data && response.data.ExceptionMessage ? response.data.ExceptionMessage : 'Unknown error'
          window.bus.$emit('openErrorModal', 'Failed to download QR code: ' + errorMessage)
        })
    }
  }
}
</script>
<style lang="scss">
.spl-user-management {
    background-color: #fff7e7;
    margin-bottom: 10px !important;
    padding: 10px 40px !important;
}
</style>
